import { useCallback, useEffect, useRef, useState } from 'react';
import { blankTemplate, readGeneratorDraft, saveGeneratorDraft } from '../../../data/templateGenerator';

// The template on the editor: its document and its details (name, description, category,
// tags), kept in this browser 400 ms after the last change. `replace` puts another template
// in (new, imported, from the gallery); the editor takes it as an undoable step.
// `onStorageFull` runs once while the browser refuses the draft (photos from the computer
// make it heavy).
export default function useTemplateDraft({ onStorageFull }) {
  const [draft, setDraft] = useState(() => readGeneratorDraft() || blankTemplate());
  const latest = useRef(draft);
  latest.current = draft;
  const warn = useRef(onStorageFull);
  warn.current = onStorageFull;
  const warned = useRef(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      try { saveGeneratorDraft(draft); warned.current = false; }
      catch { if (!warned.current) { warned.current = true; warn.current?.(); } }
    }, 400);
    return () => clearTimeout(timer);
  }, [draft]);

  const edit = useCallback(document => setDraft(current => ({ ...current, document })), []);
  const setMeta = useCallback(meta => setDraft(current => ({ ...current, meta: { ...current.meta, ...meta } })), []);
  const replace = useCallback(next => setDraft(next), []);
  return { document: draft.document, meta: draft.meta, latest, edit, setMeta, replace };
}
